const firstLetterToUp = sentence => {
  if (typeof sentence !== 'string') {
    return '';
  }
  return sentence.charAt(0).toUpperCase() + sentence.slice(1);
};

export default firstLetterToUp;
